// extracted by mini-css-extract-plugin
export default {"orderWidget":"OrderWidget_orderWidget__4Tt7e","orderWidgetContent":"OrderWidget_orderWidgetContent__NUtEc","orderWidgetFooter":"OrderWidget_orderWidgetFooter__c9IEp"};